import moment from 'moment';
import { stage as stageEnum, dateDifference } from '.';
import { IStage } from '../global';
import { ILineInTimeline, ITimelineInfo } from '../Types';

export function getStageByName(stageName: string) {
  return stageEnum[stageName];
}

export function getStageColorV2(stageName: string, theme: any) {
  switch (stageName) {
    case stageEnum.inventoryDeposit.value:
      return theme.palette.brand.purple;
    case stageEnum.remainingBalance.value:
      return theme.palette.brand.green;
    case stageEnum.freight.value:
      return theme.palette.brand.blue;
    case stageEnum['3pl'].value:
      return theme.palette.brand.pink;
    case stageEnum.marketing.value:
      return theme.palette.brand.yellow;
    case stageEnum.other.value:
      return theme.palette.brand.grey;
    case stageEnum.repaymentsStart.value:
      return theme.palette.grey[300];
    case stageEnum.complete.value:
      return theme.palette.grey[400];
    default:
      return '#ccc';
  }
}

export function getStageColor(stageName: string, theme: any) {
  switch (stageName) {
    case stageEnum.inventoryDeposit.value:
      return '#A9E7E7';
    case stageEnum.remainingBalance.value:
      return '#EEBD5E';
    case stageEnum.freight.value:
      return '#6AEE5E';
    case stageEnum['3pl'].value:
      return '#BE7AF3';
    case stageEnum.marketing.value:
      return '#EE5959';
    case stageEnum.other.value:
      return '#4aedc4';
    case stageEnum.repaymentsStart.value:
      return theme.palette.grey[300];
    case stageEnum.complete.value:
      return theme.palette.grey[400];
    default:
      return '#ccc';
  }
}

export function getLastStage(stages) {
  const dates = [];
  for (let i = 0; i < stages.length; i++) {
    if (
      !stages[i].deleted &&
      stages[i].name !== 'complete' &&
      stages[i].name !== 'repaymentsStart'
    ) {
      dates.push(moment(stages[i].start));
    }
  }
  return moment.max(dates);
}

export function getLastStageAll(stages) {
  const dates = [];
  for (let i = 0; i < stages.length; i++) {
    if (!stages[i].deleted) {
      dates.push(moment(stages[i].start));
    }
  }
  return moment.max(dates);
}

export function getLastStageFormikUpdated(values, stages) {
  const dates = [];
  stages.forEach((stage) => {
    if (stage.value !== 'repaymentsStart' && stage.value !== 'complete') {
      const date = moment(values['stage-' + stage.id + '-Date']);
      if (!values['stage-' + stage.id + '-Deleted'] && date.isValid()) {
        dates.push(moment(values['stage-' + stage.id + '-Date']));
      }
    }
  });
  return dates.length > 0 ? moment.max(dates) : moment();
}

export function getStageName(name: string) {
  const formattedName = stageEnum[name]?.shortName
    ? stageEnum[name]?.shortName
    : stageEnum[name]?.label;
  return formattedName;
}

function getStageStartDate(stage: IStage) {
  if (!stage) {
    return undefined;
  }
  return moment.utc(stage.start);
}

export function getStagePosition(line: ILineInTimeline, stage: any) {
  const startOfLine = line.visibleStartDate;
  const endOfLine = line.visibleEndDate;
  const totalDaysInLine = dateDifference(startOfLine, endOfLine);
  const stageDate = getStageStartDate(stage);
  const daysSinceStartOfLine = moment.utc(stageDate).diff(startOfLine, 'days');
  const stagePosition = (daysSinceStartOfLine / totalDaysInLine) * 100;
  return stagePosition;
}

export function stageInTimeline(stage: IStage, timelineInfo: ITimelineInfo) {
  const stageDate = getStageStartDate(stage);
  const showStage =
    stageDate >= timelineInfo.start && stageDate <= timelineInfo.end;
  return showStage;
}
